import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";

import { formatHistoryAuthorLabel } from "../../utils/formatHistoryAuthorLabel";
import { isSystemStartMessage } from "../../utils/systemStartMessage";

export type HistoryFeedMessage = {
    sid: string;
    author?: string;
    body?: string;
    dateCreated?: string;
    conversationSid?: string;
    serviceType?: string;
    agentFriendlyName?: string;
};

const formatDateTime = (value?: string) => {
    if (!value) {
        return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString("zh-CN");
};

const isCustomerAuthor = (author?: string, conversationSid?: string) => {
    if (!author) {
        return false;
    }
    if (conversationSid && author === conversationSid) {
        return false;
    }
    if (author === "Concierge") {
        return false;
    }
    return author.startsWith("FX");
};

export const HistoryMessageBubble = ({
    message,
    customerEmail
}: {
    message: HistoryFeedMessage;
    customerEmail?: string;
}) => {
    const mine = isCustomerAuthor(message.author, message.conversationSid);

    if (isSystemStartMessage(message)) {
        return null;
    }

    return (
        <Box display="flex" justifyContent={mine ? "flex-end" : "flex-start"} marginBottom="space40">
            <Box
                maxWidth="80%"
                padding="space40"
                borderRadius="borderRadius30"
                backgroundColor={mine ? "colorBackgroundPrimaryWeakest" : "colorBackground"}
            >
                <Text as="p" fontSize="fontSize20" color="colorTextWeak" marginBottom="space20">
                    {formatHistoryAuthorLabel(message.author, message.conversationSid, {
                        customerEmail,
                        agentFriendlyName: message.agentFriendlyName
                    })}{" "}
                    · {formatDateTime(message.dateCreated)}
                </Text>
                <Text as="p" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {message.body || "(附件或其他内容)"}
                </Text>
            </Box>
        </Box>
    );
};
